import React from "react";
import ReactDOM from "react-dom";
import App from "./modules/App/App";
import { isFilboPay, isRunningFromWebView } from "./modules/Shared/utils/utils";
import "./styles/index.scss";

const { REACT_APP_GTM_ENABLED, REACT_APP_GTM_ID } = process.env;
if (
  REACT_APP_GTM_ENABLED === "true" &&
  REACT_APP_GTM_ID &&
  (!isFilboPay() || !isRunningFromWebView())
) {
  const fullSnippet = `
    (function(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l !== "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "${REACT_APP_GTM_ID}");
  `;

  const scriptTag = document.createElement("script") as HTMLScriptElement;
  scriptTag.type = "text/javascript";
  scriptTag.innerHTML = fullSnippet;
  document.head.insertBefore(scriptTag, document.head.firstChild);

  const noscriptTag = document.createElement("noscript");
  noscriptTag.innerHTML = `
    <iframe
      src="https://www.googletagmanager.com/ns.html?id=${REACT_APP_GTM_ID}"
      height="0" width="0"
      style="display:none;visibility:hidden"
    ></iframe>
  `;
  document.body.insertBefore(noscriptTag, document.body.firstChild);
}

ReactDOM.render(
  <App />,

  document.getElementById("root"),
);
